/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 设为售罄或取消售罄
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productId: string,
  sellout: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/sellout/${productId}/${sellout}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
